import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonSharedModule } from '../../atoms/button/button.module';
import { ModalSharedModule } from '../modal/modal.module';

import { PromptSharedComponent } from './prompt.component';
import { PromptService } from './prompt.service';

@NgModule({
    declarations: [
        PromptSharedComponent
    ],
    imports: [
        CommonModule,

        ButtonSharedModule,
        ModalSharedModule
    ],
    providers: [
        PromptService
    ],
    exports: [
        PromptSharedComponent
    ]
})

export class PromptSharedModule {}
